import { render, staticRenderFns } from "./AdditionalFeaturesPanel.vue?vue&type=template&id=73d48234&scoped=true&"
import script from "./AdditionalFeaturesPanel.vue?vue&type=script&lang=ts&"
export * from "./AdditionalFeaturesPanel.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalFeaturesPanel.vue?vue&type=style&index=0&id=73d48234&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d48234",
  null
  
)

export default component.exports